import createWebReducers from './webReducers';
import createAdminReducers from './adminReducers';
import createEmptyInvoiceReducers from './emptyInvoiceReducers';
import createInvoiceReducers from './invoiceReducers';
import createAllowanceReducers from './allowanceReducers';
import createPrizedInvoiceReducers from './prizedInvoiceReducers';
import createTurnkeyUploadLogReducers from './turnkeyUploadLogReducers';

export default {
	createWebReducers,
	createAdminReducers,
	createEmptyInvoiceReducers,
	createInvoiceReducers,
	createAllowanceReducers,
	createPrizedInvoiceReducers,
	createTurnkeyUploadLogReducers,
};



// WEBPACK FOOTER //
// ./src/actions/reducers/index.js